import React from 'react';

const Logo = ({ show }) => {
  if (!show) return null;

  return (
    <div className="center-image-container">
      <img
        src="/images/front-image.png"
        alt="ET logo"
        style={{ width: '270px', height: 'auto' }}
      />
    </div>
  );
};

export default Logo;
